var _rect, _rect2, _rect3, _g, _rect4, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCvvInstruct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 259.27,
    height: 171.26,
    viewBox: "0 0 259.27 171.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 259.27,
    height: 159.793,
    rx: 6.033,
    fill: "#d7d7d7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 259.27,
    height: 23.404,
    transform: "translate(0 20.983)",
    fill: "#1a1a1a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 171.899,
    height: 32.277,
    transform: "translate(9.088 66.581)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(-2938.443 -4796.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M3091.644,4877.767h-1.981v-8.382h-.091a2.84,2.84,0,0,1-2.252.81v-1.6a2.528,2.528,0,0,0,2.428-1.736h1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M3094.694,4876.34l3.787-3.712c1.075-1.091,1.629-1.741,1.629-2.652a1.653,1.653,0,0,0-1.811-1.661,1.681,1.681,0,0,0-1.789,1.81h-1.88a3.383,3.383,0,0,1,3.7-3.413c2.193,0,3.679,1.337,3.679,3.163,0,1.23-.586,2.221-2.706,4.255l-1.88,1.912v.074h4.751v1.651h-7.477Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M3104.313,4874.8h2c.048.889.894,1.459,1.991,1.459,1.166,0,2-.66,2-1.624.005-.985-.814-1.677-2.194-1.677h-.964v-1.524h.964c1.129,0,1.917-.633,1.912-1.586a1.525,1.525,0,0,0-1.689-1.534,1.7,1.7,0,0,0-1.89,1.486h-1.9c.042-1.827,1.683-3.089,3.8-3.089,2.179,0,3.595,1.358,3.59,3.019a2.343,2.343,0,0,1-1.971,2.36v.085a2.49,2.49,0,0,1,2.375,2.561c.006,1.843-1.693,3.179-4.025,3.179C3106.012,4877.916,3104.367,4876.644,3104.313,4874.8Z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 48.422,
    height: 25.825,
    rx: 12.913,
    transform: "translate(137.175 62.97)",
    fill: "none",
    stroke: "#e50012",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    y2: 82.465,
    transform: "translate(161.386 88.795)",
    fill: "none",
    stroke: "#e50012",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCvvInstruct);
export default __webpack_public_path__ + "static/media/iconCVVInstruct.6ccb88f645a6a079c446abde69a90d87.svg";
export { ForwardRef as ReactComponent };